const DISPLAY_CONTEXT = {
  MODULAR_LISTING: 'MODULAR_LISTING',
  NEXT_STEP: 'NEXT_STEP',
  POSTING_PATH: 'POSTING_PATH',
};

export { DISPLAY_CONTEXT };
